import React from 'react';
import {
  RegisterOptions,
  useFormContext,
} from 'react-hook-form/dist/index.ie11';
import { CookbookInputWrapper } from 'src/components/CookbookInputWrapper/CookbookInputWrapper';
import { INPUT_REGEX } from 'src/utilities/regexPatterns';

export interface BaseAddressInputProps {
  name: string;
  id: string;
  label?: string;
  rules?: RegisterOptions;
  placeholder?: string;
}

export function BaseAddressInput({
  name,
  id,
  label = 'Address',
  rules,
  placeholder = 'e.g. 1065 Avenue of America',
}: BaseAddressInputProps): JSX.Element {
  const { errors, control } = useFormContext();

  return (
    <CookbookInputWrapper
      label={label}
      name={name}
      id={id}
      inputSize="medium"
      control={control}
      error={errors[name]}
      blockWidth
      placeholder={placeholder}
      rules={{
        maxLength: {
          value: 255,
          message: 'Max value 255',
        },
        pattern: {
          value: INPUT_REGEX,
          message: 'Address is invalid',
        },
        ...rules,
      }}
    />
  );
}
